module.exports = __webpack_public_path__ + "static/media/logo.a05a6912.svg";